import type { Application } from "../types";

/**
 * Bills and Milestones availability gate.
 * Previously locked at every stage; now enabled for all dossiers.
 */
export function areMilestonesAndBillsUnavailable(_app: Pick<Application, "subcontractor">): boolean {
  return false;
}
